import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSidenav } from '@angular/material/sidenav';
import { ErrorHelper } from '../../../shared/helpers/error.helper';
import { MessageHelper } from '../../../shared/helpers/message.helper';
import { AuthService } from '../../../shared/services/auth.service';
import { SidenavComponent } from '../../sidenav.component';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent implements OnInit {
  formGroup?: FormGroup;

  requestingAccess: boolean = false;

  @Input() sidenav?: SidenavComponent;

  constructor(
    private auth: AuthService,
    private formBuilder: FormBuilder,
    private messageHelper: MessageHelper,
    private errorHelper: ErrorHelper
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.formGroup = this.formBuilder.group({
      name: [null, Validators.required],
      email: [null, [Validators.required, Validators.email]],
      companyLegalName: [null, Validators.required],
      companyRegisterNumber: [null, Validators.required],
      notApplicable: false,
    });
  }

  toggleNotApplicable() {
    const companyRegisterNumber = this.formGroup?.get('companyRegisterNumber');

    if (this.formGroup?.value.notApplicable) {
      companyRegisterNumber?.patchValue(null);
      companyRegisterNumber?.clearValidators();
      companyRegisterNumber?.updateValueAndValidity();
    } else {
      companyRegisterNumber?.setValidators(Validators.required);
      companyRegisterNumber?.updateValueAndValidity();
    }
  }

  async register() {
    if (this.formGroup?.valid) {
      this.requestingAccess = true;

      try {
        const response = await this.auth.requestAccess(this.formGroup.value);

        if (response.error) {
          this.errorHelper.catch(response);
        } else {
          this.messageHelper.send(response.data.mensagem);
          this.backToLogin();
        }
      } catch (e) {
        this.errorHelper.catch(e);
      } finally {
        this.requestingAccess = false;
      }
    }
  }

  showFieldError(field: string) {
    const formField = this.formGroup?.get(field);
    return formField?.invalid && (formField.dirty || formField.touched);
  }

  async backToLogin() {
    await this.sidenav?.controller?.close();
    this.sidenav?.openSidenav('login');
  }
}
